import { render, staticRenderFns } from "./ThemeChanger.vue?vue&type=template&id=40b802b8&scoped=true&"
import script from "./ThemeChanger.vue?vue&type=script&lang=js&"
export * from "./ThemeChanger.vue?vue&type=script&lang=js&"
import style0 from "./ThemeChanger.vue?vue&type=style&index=0&id=40b802b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b802b8",
  null
  
)

export default component.exports